import React from "react";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import { calculateAge, getToday } from '../services/utils';
import AlertIcon from "@material-ui/icons/WarningRounded";

// کلاب کودک
class Talks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      FullName: "",
      Gender: "پسر",
      Year: 0,
      Month: 0,
      Day: 0,
      Age: "",
      MothersFullName: "",
      FathersNumber: "",
      Address: "",
      MothersPhoneNumber: "",
      Q1: "",
      Q2: "",
      canActive: 0,
      InvalidFields: []
    };

    this.props.NextBtn(false);
  }

  DataHandler = () => {
    const { HandleData } = this.props;
    const {
      FullName,
      Gender,
      Year,
      Month,
      Day,
      Age,
      MothersFullName,
      FathersNumber,
      Address,
      MothersPhoneNumber,
      Q1,
    } = this.state;
    HandleData({
      FullName,
      Gender,
      Year,
      Month,
      Day,
      Age,
      MothersFullName,
      FathersNumber,
      Address,
      MothersPhoneNumber,
      Q1,
    }, 'step3')
  };

  /**
   *
   * @param {FocusEvent<HTMLTextAreaElement | HTMLInputElement>} e
   * @constructor
   */

  ChangeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value }, this.DataHandler);
    const { Year, Month, Day } = this.state;
    if ((Year !== 0 && Month !== 0 && Day !== 0)) {
      if (Year < getToday().year && Year >= (getToday().year - 15)) {
        if (Month <= 12 && Month >= 1) {
          if (Day >= 1 && Day <= 31) {
            const age = calculateAge({ year: Year, month: Month });
            this.setState({ Age: `${age.year} سال و ${age.month} ماه ` })
          } else this.setState({ Age: '' })
        } else this.setState({ Age: '' })
      } else this.setState({ Age: 'سن کودک شما با سن تايین شده مطابقت ندارد' })
    } else {
      this.setState({ Age: `` })
    }
  };

  /**
   *
   * @param {FocusEvent<HTMLTextAreaElement | HTMLInputElement>} e
   * @constructor
   */
  ValidateField = e => {
    const INVALID_FIELDS = this.state.InvalidFields;
    if (e.target.value === "" || e.target.value === 0) {
      INVALID_FIELDS.push(e.target.name);
    } else if (INVALID_FIELDS.includes(e.target.name)) {
      const NAME = e.target.name;
      const INDEX = INVALID_FIELDS.indexOf(NAME);
      INVALID_FIELDS.splice(INDEX, 1);
    }
    this.setState({
      InvalidFields: INVALID_FIELDS
    });

    this.props.NextBtn(this.state.InvalidFields.length === 0);
  }

  Require = (FieldName) => {
    return {
      onBlur: this.ValidateField,
      error: this.state.InvalidFields.includes(FieldName)
    }
  }

  render() {
    return (
      <>
        <div className="row">
          <div className="col-12">
            <div className="row mt-3 w-100">
              <div className="col-12">
                <TextField
                  className="w-100"
                  name="FullName"
                  label="نام و نام خانوادگی کودک"
                  defaultValue={this.state.FullName}
                  onChange={this.ChangeHandler}
                  variant={"outlined"}
                  color="secondary"
                  {...this.Require("FullName")}
                />
              </div>
            </div>
            <div className="row mt-3 w-100">
              <div className="col-12">
                <FormControl
                  variant="outlined"
                  color="primary"
                  className="w-100"
                >
                  <InputLabel id="gender">جنسیت کودک</InputLabel>
                  <Select
                    label="جنسیت کودک"
                    labelId="gender"
                    name="Gender"
                    defaultValue={this.state.Gender}
                    onChange={this.ChangeHandler}
                  >
                    <MenuItem value="پسر">پسر</MenuItem>
                    <MenuItem value="دختر">دختر</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
            <div className="row mt-3 w-100">
              <div className="col-4">
                <TextField
                  className={"w-100"}
                  name={"Year"}
                  type={'number'}
                  variant={"outlined"}
                  color={"secondary"}
                  label={"سال تولد"}
                  value={this.state.Year}
                  onChange={this.ChangeHandler}
                  {...this.Require("Year")}
                />
              </div>
              <div className="col-4">
                <TextField
                  className={"w-100"}
                  name={"Month"}
                  variant={"outlined"}
                  type={'number'}
                  color={"secondary"}
                  label={"ماه تولد"}
                  value={this.state.Month}
                  onChange={this.ChangeHandler}
                  {...this.Require("Month")}
                />
              </div>
              <div className="col-4">
                <TextField
                  className={"w-100"}
                  name={"Day"}
                  variant={"outlined"}
                  color={"secondary"}
                  type={'number'}
                  label={"روز تولد"}
                  value={this.state.Day}
                  onChange={this.ChangeHandler}
                  {...this.Require("Day")}
                />
              </div>
            </div>
            <div className="row mt-3 w-100">
              <div className="col-12">
                <TextField
                  className="w-100"
                  name="Age"
                  label="سن دقیق کودک"
                  disabled
                  value={this.state.Age}
                  onChange={this.ChangeHandler}
                  variant={"outlined"}
                  color="secondary"
                />
              </div>
            </div>
            <div className="row mt-3 w-100">
              <div className="col-12">
                <TextField
                  className="w-100"
                  name="MothersFullName"
                  label="نام و نام خانوادگی مادر"
                  defaultValue={this.state.MothersFullName}
                  onChange={this.ChangeHandler}
                  variant={"outlined"}
                  color="secondary"
                  error={this.state.InvalidFields.includes("MothersFullName")}
                  onBlur={this.ValidateField}
                />
              </div>
            </div>
            <div className="row mt-3 w-100">
              <div className="col-12">
                <TextField
                  className="w-100"
                  name="MothersPhoneNumber"
                  label="شماره تماس مادر"
                  defaultValue={this.state.MothersPhoneNumber}
                  onChange={this.ChangeHandler}
                  variant={"outlined"}
                  color="secondary"
                  type="number"
                  error={this.state.InvalidFields.includes("MothersPhoneNumber")}
                  onFocus={() => {
                    this.setState({
                      canActive: 1,
                    });
                  }}
                  onBlur={(e) => {
                    this.ValidateField(e);
                    this.setState({
                      canActive: 0
                    });
                  }}
                />
                <p
                  className={`text text-warning font-weight-bold p-1 ${this.state.canActive === 1 ? "" : "d-none"
                    }`}
                >
                  <AlertIcon /> توجه: شماره تماس دارای حساب واتس اپ باشد
                </p>
              </div>
            </div>
            <div className="row mt-3 w-100">
              <div className="col-12">
                <TextField
                  className="w-100"
                  name="FathersNumber"
                  type="number"
                  label="شماره تماس پدر"
                  defaultValue={this.state.FathersNumber}
                  onChange={this.ChangeHandler}
                  variant={"outlined"}
                  color="secondary"
                />
              </div>
            </div>
            <div className="row mt-3 w-100">
              <div className="col-12">
                <TextField
                  className={"w-100"}
                  name={"Address"}
                  label={"آدرس"}
                  value={this.state.Address}
                  onChange={this.ChangeHandler}
                  variant={"outlined"}
                  color={"secondary"}
                  {...this.Require("Address")}
                />
              </div>
            </div>
            <div className="row mt-3 w-100">
              <div className="col-12">
                <TextField
                  className="w-100"
                  name="Q1"
                  label="شما تمایل دارید کلاب گفتگو در چه زمینه ای به کودک شما کمک کند ؟"
                  rowsMax={5}
                  rows={5}
                  multiline
                  defaultValue={this.state.Q1}
                  onChange={this.ChangeHandler}
                  variant={"outlined"}
                  color="secondary"
                  onFocus={() => {
                    this.setState({
                      canActive: 2,
                    });
                  }}
                  onBlur={(e) => {
                    this.setState({
                      canActive: 0,
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Talks;
